import React from 'react'
import {Box, Text} from '../../vanilla'
import {RapidInfoIcon} from '../icons'
import {useBasketStore} from '../../store/hooks/useStore'

export const getDeliveryRestrictionMessage = (
  shippingMethod: ReturnType<typeof useBasketStore>['shippingMethod'],
  options?: {isRapidOrder?: boolean; isPreBook?: boolean}
) => {
  const isEditable = !!shippingMethod?.c_isEditableAfterOrder
  const isCancellable = !!shippingMethod?.c_isCancellableAfterOrder
  const isPreBook = options?.isPreBook === true
  const isRapidBeforePreBookOverride = options?.isRapidOrder ?? shippingMethod?.id === 'Rapid_Delivery'
  const isRapid = isPreBook ? false : isRapidBeforePreBookOverride
  const orderLabel = isRapid ? 'Rapid orders' : 'this order'

  if (!isEditable && !isCancellable) {
    return `Once placed, ${orderLabel} cannot be changed or cancelled.`
  }

  if (!isEditable) {
    return `Once placed, ${orderLabel} cannot be changed.`
  }

  if (!isCancellable) {
    return `Once placed, ${orderLabel} cannot be cancelled.`
  }

  return undefined
}

interface DeliveryRestrictionNoticeProps {
  shippingMethod?: ReturnType<typeof useBasketStore>['shippingMethod']
  isRapidOrder?: boolean
  isPreBook?: boolean
}

const DeliveryRestrictionNotice = ({
  shippingMethod: shippingMethodProp,
  isRapidOrder,
  isPreBook = false,
}: DeliveryRestrictionNoticeProps) => {
  const {shippingMethod: storeShippingMethod, basket} = useBasketStore()
  const hasSlotBooked = basket?.c_windowStartTime
  const shippingMethod = shippingMethodProp ?? storeShippingMethod

  if (!hasSlotBooked) {
    return null
  }

  const restrictionMessage = getDeliveryRestrictionMessage(shippingMethod, {isRapidOrder, isPreBook})

  if (!restrictionMessage) {
    return null
  }

  return (
    <Box
      backgroundColor="infoSurface"
      width="full"
      display="flex"
      alignItems="flex-start"
      gap="4px"
      paddingX="8px"
      paddingY="8px"
      borderRadius="base"
      data-test-selector="delivery-restriction-notice"
      style={{boxSizing: 'border-box'}}
    >
      <RapidInfoIcon flexShrink="0" aria-hidden="true" style={{width: '17px', height: '17px'}} />
      <Text color="infoDefault" style={{fontSize: '14px'}} lineHeight="shorter" data-test-selector="delivery-restriction-message">
        {restrictionMessage}
      </Text>
    </Box>
  )
}

export default DeliveryRestrictionNotice
